type TAllowedUploadFileType =
    | 'jpg'
    | 'png'
    | 'gif'
    | 'jpeg'
    | 'apng'
    | 'avif'
    | 'webp'
    | 'pdf';

// order matters because it is used to display the correct accepted files text message
export const SMART_FILE_ALLOWED_FILE_TYPES: TAllowedUploadFileType[] = [
    'jpg',
    'png',
    'gif',
    'pdf',
    'jpeg',
    'apng',
    'avif',
    'webp'
];

// order matters because it is used to display the correct accepted files text message
export const LEAD_FORM_ALLOWED_FILE_TYPES: TAllowedUploadFileType[] = [
    'jpg',
    'png',
    'gif',
    'jpeg',
    'apng',
    'avif',
    'webp'
];

export const MAX_FILES_COUNT = 10;

export const MAX_FILE_SIZE_MB = 15;
